import { type ReactNode, useId } from 'react';
import { Textarea } from '@/shared/ui/textarea/textarea';
import { FieldShell } from './field-shell';

type TextareaFieldProps = {
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly error?: string | undefined;
  readonly hint?: ReactNode;
  readonly rows?: number;
  readonly placeholder?: string;
};

export function TextareaField({ value, onChange, rows = 3, placeholder, ...shell }: TextareaFieldProps) {
  const id = useId();
  return (
    <FieldShell id={id} {...shell}>
      <Textarea
        id={id}
        rows={rows}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-20 text-base md:text-sm"
      />
    </FieldShell>
  );
}
